import { render } from "./EditQuotaTariff.vue?vue&type=template&id=56398a7c&scoped=true"
import script from "./EditQuotaTariff.vue?vue&type=script&lang=js"
export * from "./EditQuotaTariff.vue?vue&type=script&lang=js"

import "./EditQuotaTariff.vue?vue&type=style&index=0&id=56398a7c&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56398a7c"]])

export default __exports__